import React from 'react';
import { Link } from 'react-router-dom';
import { Users, FolderOpen, CreditCard, ArrowRight, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { createPageUrl } from '../../utils';

export default function ModuleCards({ stats }) {
  const modules = [
    {
      title: 'HRIS',
      description:
        'Human Resource Information System - Kelola data pegawai, absensi, cuti, KPI dan penggajian',
      icon: Users,
      color: 'from-emerald-500 to-emerald-600',
      link: 'HRISDashboard',
      stats: `${stats.employees} Pegawai`,
      features: ['Data Pegawai', 'Struktur Organisasi', 'Absensi & Cuti', 'KPI & Penggajian'],
    },
    {
      title: 'Arsip Terintegrasi',
      description:
        'Centralized Document Management System untuk HRIS, Kredit, Debitur, dan Legal - Single Source of Truth',
      icon: FolderOpen,
      color: 'from-purple-500 to-purple-600',
      link: 'ArchiveDashboard',
      stats: 'DMS Terpusat',
      features: ['Repository Dokumen', 'Validasi & Versioning', 'Audit Trail', 'Multi-Module'],
    },
    {
      title: 'Analisis Kredit',
      description: 'Sistem analisis kelayakan kredit dengan scoring 5C dan workflow approval',
      icon: CreditCard,
      color: 'from-blue-500 to-blue-600',
      link: 'CreditDashboard',
      stats: `${stats.creditApplications} Aplikasi`,
      features: ['Aplikasi Kredit', 'Scoring 5C', 'Workflow Approval', 'Laporan Kelayakan'],
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {modules.map((module, index) => (
        <motion.div
          key={module.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 + index * 0.1 }}
        >
          <div className="bg-white rounded-lg border shadow-sm h-full hover:shadow-lg transition-all group overflow-hidden flex flex-col">
            <div className={`h-2 bg-gradient-to-r ${module.color}`} />
            <div className="p-6 pb-2">
              <div className="flex items-start justify-between">
                <div
                  className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${module.color} flex items-center justify-center shadow-lg`}
                >
                  <module.icon className="w-7 h-7 text-white" />
                </div>
                <span className="px-2.5 py-0.5 bg-gray-100 text-gray-700 text-xs font-medium rounded-full">
                  {module.stats}
                </span>
              </div>
              <h3 className="text-xl font-semibold mt-4">{module.title}</h3>
              <p className="text-gray-500 text-sm mt-1">{module.description}</p>
            </div>
            <div className="p-6 pt-0 flex-1 flex flex-col">
              <div className="space-y-2 mb-4 flex-1">
                {module.features.map(feature => (
                  <div key={feature} className="flex items-center gap-2 text-sm text-gray-600">
                    <CheckCircle className="w-4 h-4 text-green-500" />
                    {feature}
                  </div>
                ))}
              </div>
              <Link to={createPageUrl(module.link)} className="mt-auto">
                <button
                  className={`w-full bg-gradient-to-r ${module.color} hover:opacity-90 text-white py-2 px-4 rounded-md font-medium flex items-center justify-center group-hover:shadow-md transition-all`}
                >
                  Akses Modul
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </button>
              </Link>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
